export const SW_DOWNLOAD_SELECTION_TEXTS = {
  downloadStart: {
    NOW: () => 'Software will start downloading to devices immediately upon starting the SW update process.',
    SCHEDULE: (scheduleTime) => `Software will start downloading to devices at ${scheduleTime}`
  },
  activationStart: {
    NOW: () => 'Software will be activated on devices as soon as the download has completed for each device.',
    SCHEDULE: (scheduleTime) =>
      `Software will wait to be activated until ${scheduleTime}. Devices that complete their download after this time will be activated immediately upon download completion.`
  }
};
